import React from 'react';
import { Section } from './ui/Section';
import { PRODUCT } from '../data/content';
const credentials = ['Victoria', '29 años', 'Licenciada en Turismo', 'Agente de viajes'];
const questions = ['¿Por dónde empiezo?', '¿Qué ciudades elijo?', '¿Cuántos días necesito?', '¿Cómo organizo los gastos?', '¿Qué reservo primero?'];
export function AboutVictoria() {
  return <Section tone="sand" className="py-14 sm:py-16 lg:py-20" data-id="element-15" data-mp="35g1eccomfjd7">
      <div className="grid grid-cols-1 gap-8 sm:grid-cols-[0.68fr_1.32fr] sm:gap-10 lg:gap-14" data-id="element-16" data-mp="6urk3e7edxhu">
        <div className="mx-auto w-[66%] max-w-[250px] sm:mx-0 sm:w-full sm:max-w-none" data-id="element-17" data-mp="1yasub4wj30j">
          <img src={PRODUCT.authorPhoto} alt="Victoria, creadora de la guía Europa por Primera Vez" className="w-full rounded-xl object-cover shadow-[0_26px_40px_-28px_rgba(27,51,64,0.5)]" data-id="element-18" data-mp="3tam0p6a66cdb" />
          <p className="mt-4 hidden items-center gap-3 font-sans text-[10.5px] uppercase tracking-[0.14em] text-hierro sm:flex" data-id="element-19" data-mp="pmu0cog4nbrk">
            <span aria-hidden="true" className="h-px w-6 bg-travertino" data-id="element-20" data-mp="ku9ec93gq2yl" />
            Atlas de Viajes
          </p>
        </div>

        <div className="text-center sm:text-left" data-id="element-21" data-mp="156np065jw0zm">
          <h2 className="font-display text-[29px] font-bold leading-none text-oceano sm:text-[40px]" data-id="element-22" data-mp="194lcn4joaf0w">
            Hola, soy Victoria
          </h2>
          <p className="mt-3 font-sans text-[10px] font-medium uppercase tracking-[0.2em] text-caribe sm:text-[10.5px]" data-id="element-23" data-mp="vcnj422g2rpu">
            Lic. en Turismo · Agente de viajes
          </p>

          

          <p className="mt-5 font-sans text-[13px] leading-relaxed text-hierro sm:text-[14px]" data-id="element-24" data-mp="lin7rigkkq8o">
            Una de las cosas que más disfruto de mi trabajo es ayudar a personas a organizar{' '}
            <strong className="font-medium text-oceano" data-id="element-25" data-mp="chyuipz02twu">
              ese viaje a Europa que vienen soñando hace tanto tiempo
            </strong>
            .
          </p>

          <div className="mt-7 border-t border-travertino/40 pt-6" data-id="element-26" data-mp="26u6n3wnumypg">
            <p className="font-sans text-[12.5px] leading-relaxed text-hierro sm:text-[13px]" data-id="element-27" data-mp="2bszvxbs6y1ja">
              Con los años me di cuenta de que, cuando alguien empieza a planificar su primer viaje,
              aparecen siempre las mismas dudas:
            </p>
            <ul className="mt-4 flex flex-wrap justify-center gap-2 sm:justify-start" data-id="element-28" data-mp="20ddfe5vvg80b">
              {questions.map(question => <li key={question} className="rounded-full bg-white px-3.5 py-2 font-sans text-[12px] leading-none text-oceano/85 sm:text-[12.5px]" data-id="element-29" data-mp="1vek14b8rgcz3">
                  {question}
                </li>)}
            </ul>
          </div>

          <div className="mt-7" data-id="element-30" data-mp="2o40sd5kn9ntq">
            <p className="font-display text-[21px] font-bold leading-snug text-oceano sm:text-[26px]" data-id="element-31" data-mp="2o52d61rgpoon">
              Por eso decidí crear{' '}
              <span className="text-caribe" data-id="element-32" data-mp="2edo4b3dmfciu">Europa por Primera Vez</span>.
            </p>
            <p className="mt-3 font-sans text-[12.5px] leading-relaxed text-hierro sm:text-[13.5px]" data-id="element-33" data-mp="3bsa93t303le0">
              Una guía práctica donde reuní{' '}
              <strong className="font-medium text-oceano" data-id="element-34" data-mp="370ip61ecodwu">información, herramientas y tips</strong> que
              uso para planificar viajes, pensada especialmente para quienes quieren{' '}
              <strong className="font-medium text-oceano" data-id="element-35" data-mp="3jcl24f6l9ewe">armar su itinerario por su cuenta</strong>,
              pero con una estructura clara que los ayude a tomar mejores decisiones.
            </p>
            <p className="mt-3 font-sans text-[12.5px] italic leading-relaxed text-oceano/70 sm:text-[13.5px]" data-id="element-36" data-mp="3tbtreuqie5cf">
              Mi objetivo es que puedas organizar tu viaje con más claridad, aprovechar mejor tu
              presupuesto y llegar a Europa sintiendo que tenés todo mucho más ordenado.
            </p>
          </div>

          
        </div>
      </div>
    </Section>;
}